import * as yup from "yup";
import { useEffect, useState } from "react";
import { useForm } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import { IoSaveOutline } from "react-icons/io5";
import { FaCircleNotch } from "react-icons/fa";
import ReactSelect from "./../../../components/common/ReactSelect";
import accountService from "../../../services/accountService";
import Toaster from "./../../../components/common/Toaster";

const schema = yup.object({
  status: yup.object().shape({
    label: yup.string().required("Please select status."),
    value: yup.string().required("Please select status."),
  }),
});

const StatusForm = ({ data, setData, isLoading, setLoading, onSuccess }) => {
  const [statuses, setStatuses] = useState([]);

  const {
    register,
    handleSubmit,
    setValue,
    control,
    formState: { errors },
  } = useForm({ resolver: yupResolver(schema) });

  const onSubmit = async (info) => {
    try {
      setLoading(true);

      const account = { ...data };
      account["account_status"] = parseInt(info.status.value);
      account["account_status_type"] = info.status.label;
      setData(account);

      await accountService.saveAccountStatusAsync(data.id, info);

      Toaster.Success("Status Updated Successfully");
      onSuccess();
    } catch (ex) {
      Toaster.Error("Something went wrong.");
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    const result = accountService.getAccountStatuses();
    setStatuses(result);
  }, []);

  useEffect(() => {
    const populateForm = () => {
      const selected_status = {
        label: data.account_status_type,
        value: data.account_status,
      };

      setValue("status", selected_status);
    };

    populateForm();
  }, [data, setValue]);

  return (
    <form onSubmit={handleSubmit(onSubmit)} className="p-8 space-y-6">
      <div className="grid grid-cols-2">
        <div className="col-span-2">
          <ReactSelect
            id="status-dropdown"
            name="status"
            title="Status"
            options={statuses}
            control={control}
            register={register("status")}
            errors={errors}
          />
        </div>
      </div>
      <div className="grid grid-2 pt-2">
        <div className="col-span-2">
          <button
            type="submit"
            className="button button-primary disabled:opacity-70 disabled:cursor-not-allowed"
            disabled={isLoading}
          >
            {isLoading && <FaCircleNotch className="animate-spin mr-3" />}
            {!isLoading && <IoSaveOutline className="mr-3" />}
            Save Changes
          </button>
        </div>
      </div>
    </form>
  );
};

export default StatusForm;
